"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphTenContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../../../stores/RootStore");
const ParagraphTenContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null,
            translate('gdpr.privacy.notification.paragraph.ten.text1'),
            "\u00A0",
            react_1.default.createElement(lib_1.Anchor, { url: "mailto:info@telia.ee" }, "info@telia.ee"),
            "."),
        react_1.default.createElement("p", null,
            translate('gdpr.privacy.notification.paragraph.ten.text2'),
            "\u00A0",
            react_1.default.createElement(lib_1.Anchor, { url: "mailto:privacy@telia.ee" }, "privacy@telia.ee"),
            ". ",
            translate('gdpr.privacy.notification.paragraph.ten.text3'),
            "\u00A0(",
            react_1.default.createElement(lib_1.Anchor, { url: "https://www.aki.ee/et" }, "https://www.aki.ee/et"),
            ")"),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.ten.text4')),
        react_1.default.createElement("p", null,
            translate('gdpr.privacy.notification.paragraph.ten.text5'),
            "\u00A0",
            react_1.default.createElement(lib_1.Anchor, { url: "https://secure.ethicspoint.eu/domain/media/en/gui/101615/index.html" }, translate('gdpr.privacy.notification.paragraph.ten.link1')),
            translate('gdpr.privacy.notification.paragraph.ten.text6')),
        react_1.default.createElement("p", null,
            translate('gdpr.privacy.notification.paragraph.ten.text7'),
            react_1.default.createElement(lib_1.Anchor, { url: "https://www.teliacompany.com/en/about-the-company/privacy" }, translate('gdpr.privacy.notification.paragraph.ten.link2')),
            "."),
        react_1.default.createElement("p", null,
            translate('gdpr.privacy.notification.paragraph.ten.text8'),
            react_1.default.createElement(lib_1.Anchor, { url: "https://www.teliacompany.com/assets/u5c1v3pt22v8/1Y56YkPHW2GIGDqyi9ISUe/1db640677a00ecc7fc90eedb5cc310ca/group-policy---security.pdf" }, translate('gdpr.privacy.notification.paragraph.ten.link2')),
            ".")));
};
exports.ParagraphTenContent = ParagraphTenContent;
